// import React from 'react';
// import AbutFaq from '../Components/AbutFaq'; // File path check karo

// import imgg from '../Assets/Images/High-Speed-Industrial-Robot-Yellow-LWFCH6E.png';
// import image from '../Assets/Images/Production.png'
// import vision from '../Assets/Images/Group136.png'
// // import AboutFaq from '../Components/AbutFaq';
// const About = () => {
	

  
	
//   return (
// <>

// <div class="page-template page-template-elementor_header_footer page page-id-1050 jkit-color-scheme elementor-default elementor-template-full-width elementor-kit-3 elementor-page elementor-page-1050">
// 	<div id="page" class="jkit-template  site">
// 		<div data-elementor-type="wp-page" data-elementor-id="1050" class="elementor elementor-1050">
// 			<div data-elementor-type="wp-page" data-elementor-id="1050" class="elementor elementor-1050">
// 				<div class="elementor-element elementor-element-bdbb4a9 e-flex e-con-boxed e-con e-parent" data-id="bdbb4a9" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;gradient&quot;,&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
// 					<div class="e-con-inner">
// 						<div class="elementor-element elementor-element-2d2b035 e-con-full e-flex e-con e-child" data-id="2d2b035" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
// 							<div class="elementor-element elementor-element-30e7754 elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-heading" data-id="30e7754" data-element_type="widget" data-settings="{&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="heading.default">
// 								<div class="elementor-widget-container">
// 									<h5 class="elementor-heading-title elementor-size-default">About Us</h5>		
// 								</div>
// 							</div>
// 							<div class="elementor-element elementor-element-641798f elementor-widget__width-initial elementor-widget-mobile__width-inherit elementor-invisible elementor-widget elementor-widget-jkit_animated_text" data-id="641798f" data-element_type="widget" data-settings="{&quot;_animation_delay&quot;:200,&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="jkit_animated_text.default">
// 								<div class="elementor-widget-container">
// 									<div  class="jeg-elementor-kit jkit-animated-text jeg_module_1050_2_676b7a2b716bd"  data-style="highlighted" data-text="Revolution" data-shape="underline">
// 										<h1 class="animated-text"><span class="normal-text style-color">Creating the</span>
// 											<span class="normal-text style-color">  Future: 
// 											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 150" preserveAspectRatio="none">
// 													<path class="style-color"  d="M3,77.5s200.54-11,493,0" transform="translate(-2.75 -68.11)"/>
// 												</svg>
// 											</span>
// 											{/* <span class="dynamic-wrapper style-color">
// 												<span class="dynamic-text"></span>
											
// 											</span> */}
// 											<span class="normal-text style-color">Intelligent Design  & Advanced Manufacturing  </span>
// 										</h1>
// 									</div>
// 								</div>
// 							</div>
// 							{/* <div class="elementor-element elementor-element-12b1148 elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-text-editor" data-id="12b1148" data-element_type="widget" data-settings="{&quot;_animation_delay&quot;:300,&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="text-editor.default">
// 								<div class="elementor-widget-container">
// 								Embark on a transformative journey into Industry 4.0 with our groundbreaking automation and special-purpose machines.
// 								</div>
// 							</div> */}
// 						</div>
// 					</div>
// 				</div>
				
// 		<div class="elementor-element elementor-element-3fd02d5 e-flex e-con-boxed e-con e-parent" data-id="3fd02d5" data-element_type="container" data-settings='{"content_width":"boxed"}' data-core-v316-plus="true">
//     <div class="e-con-inner">
//         <div class="elementor-element elementor-element-836cbbe e-con-full e-flex e-con e-child" data-id="836cbbe" data-element_type="container" data-settings='{"content_width":"full"}'>
//             <div class="elementor-element elementor-element-b29317c e-con-full e-flex e-con e-child" data-id="b29317c" data-element_type="container" data-settings='{"content_width":"full"}'>
//                 <div class="elementor-element elementor-element-d400f8d elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="d400f8d" data-element_type="widget" data-widget_type="heading.default">
//                     <div class="elementor-widget-container">
//                         <h5 class="elementor-heading-title elementor-size-default">Our Story</h5>
//                     </div>
//                 </div>
//                 <div class="elementor-element elementor-element-93b6ef8 elementor-widget__width-initial elementor-widget-tablet__width-initial elementor-widget elementor-widget-jkit_heading" data-id="93b6ef8" data-element_type="widget" data-widget_type="jkit_heading.default">
//                     <div className="elementor-widget-container">
//                         <div className="jeg-elementor-kit jkit-heading align-left align-tablet- align-mobile- jeg_module_1050_4_676b7a2b79e09">
//                             <div className="heading-section-title display-inline-block">
//                                 <h4 className="heading-title">Welcome to HHG Industries, where we've been delivering <span className="style-color"><span>innovation and transformative</span></span> automation solutions since 2024.</h4>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="elementor-element elementor-element-dd3e9a5 elementor-widget__width-initial elementor-widget elementor-widget-text-editor" data-id="dd3e9a5" data-element_type="widget" data-widget_type="text-editor.default">
//                     <div className="elementor-widget-container">
//                         At HHG Industries, we deliver innovative design and manufacturing solutions for automotive, aeronautical industry, infrastructure, and other various sectors. We integrate advanced technologies including artificial intelligence, and robotics, when combined together with human interaction contributes towards a proliferating and sustainable environment in the future.
//                     </div>
//                 </div>
//             </div>
//             <div className="elementor-element elementor-element-9ee2b7b e-con-full e-flex e-con e-child" data-id="9ee2b7b" data-element_type="container" data-settings='{"content_width":"full"}'>
//                 <div className="elementor-element elementor-element-6f785b5 elementor-widget elementor-widget-image" data-id="6f785b5" data-element_type="widget" data-widget_type="image.default">
//                     <div className="elementor-widget-container">
//                         <img decoding="async" className="single-image" src={image} alt="HHG Industries Automation" style={{width: '100%', height: '500px', objectFit: 'contain'}} />
//                     </div>
//                 </div>
//             </div>
//         </div>
//     </div>
// </div>
		
// 		<div class="elementor-element elementor-element-d114a46 e-flex e-con-boxed e-con e-parent" data-id="d114a46" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
// 					<div class="e-con-inner">
// 		<div class="elementor-element elementor-element-740107e e-con-full e-flex e-con e-child" data-id="740107e" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
// 				<div class="elementor-element elementor-element-b8b1603 elementor-widget elementor-widget-image" data-id="b8b1603" data-element_type="widget" data-widget_type="image.default">
// 				<div class="elementor-widget-container">
// 			<img decoding="async" width="800" height="964" src={vision} class="attachment-large size-large wp-image-1114" alt="Robotic Arm modern industrial technology. Automated production c" sizes="(max-width: 800px) 100vw, 800px" />	</div>
// 				</div>
// 				</div>
// 		<div class="elementor-element elementor-element-db0e5e2 e-con-full e-flex e-con e-child" data-id="db0e5e2" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
// 				<div class="elementor-element elementor-element-869af5c elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="869af5c" data-element_type="widget" data-widget_type="heading.default">
// 				<div class="elementor-widget-container">
// 			<h5 class="elementor-heading-title elementor-size-default">Our Vision & Mission</h5>		</div>
// 				</div>
// 				<div class="elementor-element elementor-element-8407bdb elementor-widget__width-inherit elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-heading" data-id="8407bdb" data-element_type="widget" data-widget_type="heading.default">
// 				<div class="elementor-widget-container">
// 			<h2 class="elementor-heading-title elementor-size-default"></h2>		</div>
// 				</div>
// 				<div class="elementor-element elementor-element-ceb0f99 elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-jkit_feature_list" data-id="ceb0f99" data-element_type="widget" data-widget_type="jkit_feature_list.default">
// 				<div class="elementor-widget-container">
// 			<div  class="jeg-elementor-kit jkit-feature-list icon-position-left icon-position-left icon-position-left jeg_module_1050_9_676b7a2b8a3d4" ><ul class="feature-list-items shape-circle shape-view-stacked connector-type-classic"><li class="feature-list-item elementor-repeater-item-5c9e9bc">
// 				<span class="connector"></span>
// 				<div class="feature-list-icon-box">
// 					<div class="feature-list-icon-inner">
// 						<span class="feature-list-icon">
// 							<i aria-hidden="true" class="fas fa-circle"></i>
// 						</span>
// 					</div>
// 				</div>
// 				<div class="feature-list-content-box">
// 					<h4 class="feature-list-title">Vision</h4><p class="feature-list-content">To develop and deliver cutting-edge AI-based Design for Manufacturing (DFM) solutions that empower our customers to streamline their products with high-added value and innovative technological solutions through sustainable and competitive growth development processes and optimize manufacturing efficiency in a significantly reduced timeframe.</p>
// 				</div>
// 			</li><li class="feature-list-item elementor-repeater-item-0b496d9">
// 				<span class="connector"></span>
// 				<div class="feature-list-icon-box">
// 					<div class="feature-list-icon-inner">
// 						<span class="feature-list-icon">
// 							<i aria-hidden="true" class="fas fa-circle"></i>
// 						</span>
// 					</div>
// 				</div>
// 				<div class="feature-list-content-box">
// 					<h4 class="feature-list-title"> Mission</h4>
// 					<p class="feature-list-content">We deliver global and innovative design and manufacturing solutions for the Automotive, MES, EV, Aeronautical, Infrastructure, and other industrial sectors, integrating advanced technologies such as robotics and artificial intelligence that together with human interaction contribute to more sustainable development.</p>
// 				</div>
// 			</li></ul></div>		</div>
// 				</div>
// 				</div>
// 					</div>
// 				</div>
				
// {/* 
				
// 	<div className="join-team-container">
      
//       <div className="text-container">
//         <h1>
//           Keen to Contribute Your <span className="highlight">Talents?</span>? Join Our Team!
//         </h1>
//         <p>
//           Ready to join us. Explore exciting opportunities to be part of our dynamic team.
//         </p>
       
//       </div>
// 	  <div className="images-containers">
//         <img
//           src={imgg}
//           alt="Robotic Arm"
//           className="robotic-arm"
//         />
//       </div>
//     </div> */}
	
							
// 		<div class="elementor-element elementor-element-f7b25e1 e-flex e-con-boxed e-con e-parent" data-id="f7b25e1" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
// 					<div class="e-con-inner">
// 		<div class="elementor-element elementor-element-ab1c5ab e-con-full e-flex e-con e-child" data-id="ab1c5ab" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;gradient&quot;,&quot;content_width&quot;:&quot;full&quot;}">
// 				<div class="elementor-element elementor-element-13efc09 elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="13efc09" data-element_type="widget" data-widget_type="heading.default">
// 				<div class="elementor-widget-container">
// 			<h2 class="elementor-heading-title elementor-size-default">Elevate Your Efficiency Now! Dive into the Future with Our Complete Solutions.</h2>		</div>
// 				</div>
// 				<div class="elementor-element elementor-element-0d45836 elementor-widget__width-initial elementor-widget elementor-widget-text-editor" data-id="0d45836" data-element_type="widget" data-widget_type="text-editor.default">
// 				<div class="elementor-widget-container">
// 							<p>Revolutionize the way you operate with our cutting-edge automation solutions.</p>						</div>
// 				</div>
// 		<div class="elementor-element elementor-element-b70abb5 e-flex e-con-boxed e-con e-child" data-id="b70abb5" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}">
// 					<div class="e-con-inner">
// 				<div class="elementor-element elementor-element-bf310c0 elementor-widget__width-auto elementor-widget-mobile__width-inherit elementor-widget elementor-widget-jkit_button" data-id="bf310c0" data-element_type="widget" data-widget_type="jkit_button.default">
// 				<div class="elementor-widget-container">
// 			<div  class="jeg-elementor-kit jkit-button  icon-position-before jeg_module_1050_10_676b7a2b8d0aa" ><a href="Contactus"  class="jkit-button-wrapper"  >Contact Us</a></div>		</div>
// 				</div>
// 				<div class="elementor-element elementor-element-6c6556c elementor-widget__width-auto elementor-widget-mobile__width-inherit elementor-widget elementor-widget-jkit_button" data-id="6c6556c" data-element_type="widget" data-widget_type="jkit_button.default">
// 				<div class="elementor-widget-container">
// 			<div  class="jeg-elementor-kit jkit-button  icon-position-after jeg_module_1050_11_676b7a2b8db1a" ><a href="#"  class="jkit-button-wrapper"  >Learn More<i aria-hidden="true" class="jki jki-right-arrow-light"></i></a></div>		</div>
// 				</div>
// 					</div>
// 				</div>
// 				</div>
// 					</div>
// 				</div>




// 		{/* <div class="elementor-element elementor-element-3ee3e4e e-flex e-con-boxed e-con e-parent" data-id="3ee3e4e" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
// 					<div class="e-con-inner">
// 		<div class="elementor-element elementor-element-1ffddb6 e-con-full e-flex e-con e-child" data-id="1ffddb6" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
// 		<div class="elementor-element elementor-element-e65bfd9 e-con-full e-flex e-con e-child" data-id="e65bfd9" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
// 				<div class="elementor-element elementor-element-66914de elementor-widget elementor-widget-jkit_team" data-id="66914de" data-element_type="widget" data-widget_type="jkit_team.default">
// 				<div class="elementor-widget-container">
// 			<div  class="jeg-elementor-kit jkit-team style-overlay overlay-bottom jeg_module_1050_12_676b7a2b9325e" ><div class="profile-card "><img decoding="async" src="../wp-content/uploads/sites/428/2024/01/cheerful-male-builder-standing-at-construction-site-e1694073993679.jpg" />
//                 <div class="hover-area alignment-center"><div class="profile-body">
//                 <h2 class="profile-title"></h2>
//                 <p class="profile-designation"></p>
                
//                 <ul class="social-list"><li class="social-icon elementor-repeater-item-ab08324"><a href="https://facebook.com/"  ><i aria-hidden="true" class="jki jki-facebook-light"></i></a></li><li class="social-icon elementor-repeater-item-c3d28e7"><a href="https://twitter.com/"  ><i aria-hidden="true" class="fab fa-twitter"></i></a></li><li class="social-icon elementor-repeater-item-518f2b5"><a href="https://instagram.com/"  ><i aria-hidden="true" class="jki jki-instagram-1-light"></i></a></li></ul>
//             </div></div>
//             </div></div>		</div>
// 				</div>
// 		<div class="elementor-element elementor-element-f13ffb0 e-con-full e-flex e-con e-child" data-id="f13ffb0" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;background_background&quot;:&quot;classic&quot;}">
// 				<div class="elementor-element elementor-element-ccf4a8f elementor-widget elementor-widget-jkit_heading" data-id="ccf4a8f" data-element_type="widget" data-widget_type="jkit_heading.default">
// 				<div class="elementor-widget-container">
// 			<div  class="jeg-elementor-kit jkit-heading  align-center align-tablet- align-mobile- jeg_module_1050_13_676b7a2b94ee5" ><div class="heading-section-title  display-inline-block"><h4 class="heading-title">Employee 1</h4></div><div class="heading-section-description"><p>Designer</p></div></div>		</div>
// 				</div>
// 				</div>
// 				</div>
// 		<div class="elementor-element elementor-element-6b258fa e-con-full e-flex e-con e-child" data-id="6b258fa" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
// 				<div class="elementor-element elementor-element-9175ddb elementor-widget elementor-widget-jkit_team" data-id="9175ddb" data-element_type="widget" data-widget_type="jkit_team.default">
// 				<div class="elementor-widget-container">
// 			<div  class="jeg-elementor-kit jkit-team style-overlay overlay-bottom jeg_module_1050_14_676b7a2b97246" ><div class="profile-card "><img decoding="async" src="../wp-content/uploads/sites/428/2024/01/architect-man-working-with-blueprints-for-architectural-plan-engineer-sketching-a-construction-e1694073243258.jpg" />
//                 <div class="hover-area alignment-center"><div class="profile-body">
//                 <h2 class="profile-title"></h2>
//                 <p class="profile-designation"></p>
                
//                 <ul class="social-list"><li class="social-icon elementor-repeater-item-ab08324"><a href="https://facebook.com/"  ><i aria-hidden="true" class="jki jki-facebook-light"></i></a></li><li class="social-icon elementor-repeater-item-c3d28e7"><a href="https://twitter.com/"  ><i aria-hidden="true" class="fab fa-twitter"></i></a></li><li class="social-icon elementor-repeater-item-518f2b5"><a href="https://instagram.com/"  ><i aria-hidden="true" class="jki jki-instagram-1-light"></i></a></li></ul>
//             </div></div>
//             </div></div>		</div>
// 				</div>
// 		<div class="elementor-element elementor-element-979648d e-con-full e-flex e-con e-child" data-id="979648d" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;background_background&quot;:&quot;classic&quot;}">
// 				<div class="elementor-element elementor-element-e88b2fd elementor-widget elementor-widget-jkit_heading" data-id="e88b2fd" data-element_type="widget" data-widget_type="jkit_heading.default">
// 				<div class="elementor-widget-container">
// 			<div  class="jeg-elementor-kit jkit-heading  align-center align-tablet- align-mobile- jeg_module_1050_15_676b7a2b99375" ><div class="heading-section-title  display-inline-block"><h4 class="heading-title">Employee 2</h4></div><div class="heading-section-description"><p>Head of Operations</p></div></div>		</div>
// 				</div>
// 				</div>
// 				</div>
// 		<div class="elementor-element elementor-element-ba5d339 e-con-full e-flex e-con e-child" data-id="ba5d339" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
// 				<div class="elementor-element elementor-element-939a63c elementor-widget elementor-widget-jkit_team" data-id="939a63c" data-element_type="widget" data-widget_type="jkit_team.default">
// 				<div class="elementor-widget-container">
// 			<div  class="jeg-elementor-kit jkit-team style-overlay overlay-bottom jeg_module_1050_16_676b7a2b9c779" ><div class="profile-card "><img decoding="async" src="../wp-content/uploads/sites/428/2024/01/joyful-man-construction-worker-standing-outdoors-at-industrial-site-e1694072989208.jpg" />
//                 <div class="hover-area alignment-center"><div class="profile-body">
//                 <h2 class="profile-title"></h2>
//                 <p class="profile-designation"></p>
                
//                 <ul class="social-list"><li class="social-icon elementor-repeater-item-ab08324"><a href="https://facebook.com/"  ><i aria-hidden="true" class="jki jki-facebook-light"></i></a></li><li class="social-icon elementor-repeater-item-c3d28e7"><a href="https://twitter.com/"  ><i aria-hidden="true" class="fab fa-twitter"></i></a></li><li class="social-icon elementor-repeater-item-518f2b5"><a href="https://instagram.com/"  ><i aria-hidden="true" class="jki jki-instagram-1-light"></i></a></li></ul>
//             </div></div>
//             </div></div>		</div>
// 				</div>
// 		<div class="elementor-element elementor-element-ab2e290 e-con-full e-flex e-con e-child" data-id="ab2e290" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;background_background&quot;:&quot;classic&quot;}">
// 				<div class="elementor-element elementor-element-f553239 elementor-widget elementor-widget-jkit_heading" data-id="f553239" data-element_type="widget" data-widget_type="jkit_heading.default">
// 				<div class="elementor-widget-container">
// 			<div  class="jeg-elementor-kit jkit-heading  align-center align-tablet- align-mobile- jeg_module_1050_17_676b7a2b9e33f" ><div class="heading-section-title  display-inline-block"><h4 class="heading-title">Employee 3</h4></div><div class="heading-section-description"><p>Engineer</p></div></div>		</div>
// 				</div>
// 				</div>
// 				</div>
// 				</div>
// 					</div>
// 				</div> */}
// 				</div>
// 				<AbutFaq />
// 		</div>
// 	</div>
// </div>		</>

//   );
// };

// export default About;

import React from 'react';
import AbutFaq from '../Components/AbutFaq';
import imgg from '../Assets/Images/High-Speed-Industrial-Robot-Yellow-LWFCH6E.png';
import image from '../Assets/Images/Production.png';
import vision from '../Assets/Images/Group136.png';

const About = () => {
  return (
    <>
      <style>
        {`
          /* Base responsive improvements */
          .e-con, .e-con-inner, .e-con-full {
            width: 100%;
          }

          /* Tablet and mobile styles */
          @media (max-width: 1024px) {
            .e-con.e-flex, .e-con-inner {
              flex-direction: column !important;
              padding-left: 20px !important;
              padding-right: 20px !important;
            }

            .e-con-full {
              width: 100% !important;
              margin-bottom: 30px;
            }

            .elementor-widget__width-initial,
            .elementor-widget__width-inherit {
              max-width: 100% !important;
              width: 100% !important;
            }

            .jkit-heading .heading-title {
              font-size: 1.8rem !important;
              line-height: 1.3 !important;
            }

            .jkit-feature-list .feature-list-content {
              font-size: 0.95rem !important;
            }

            img.single-image {
              height: auto !important;
              max-height: 350px;
              object-fit: contain;
            }

            .jkit-button-wrapper {
              padding: 12px 24px !important;
              font-size: 1rem !important;
              display: inline-block;
              margin-bottom: 15px;
              text-align: center;
            }
          }

          /* Mobile specific */
          @media (max-width: 768px) {
            .elementor-heading-title {
              font-size: 1.5rem !important;
            }

            h5.elementor-heading-title {
              font-size: 1.2rem !important;
            }

            .animated-text .normal-text {
              font-size: 1.8rem !important;
              display: block;
            }

            .jkit-feature-list .feature-list-item {
              flex-direction: column;
              align-items: flex-start;
            }

            .feature-list-icon-box {
              margin-bottom: 10px;
            }

            .feature-list-content-box h4 {
              font-size: 1.3rem;
            }

            .e-con .e-con-inner .elementor-element {
              width: 100% !important;
            }

            .e-con[data-id="d114a46"] .e-con-inner,
            .e-con[data-id="3fd02d5"] .e-con-inner {
              flex-direction: column !important;
            }

            .e-con[data-id="740107e"] img {
              width: 100%;
              height: auto;
            }
          }

          .elementor-widget-image img {
            max-width: 100%;
            height: auto;
          }

          .feature-list-items {
            display: flex;
            flex-direction: column;
          }

          .feature-list-item {
            margin-bottom: 24px;
          }

          /* Force buttons to stack vertically (as shown in the image) */
          .vertical-buttons {
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            gap: 15px !important;
          }
          .vertical-buttons .elementor-widget {
            width: auto !important;
            max-width: 100% !important;
          }
        `}
      </style>

      <div className="page-template page-template-elementor_header_footer page page-id-1050 jkit-color-scheme elementor-default elementor-template-full-width elementor-kit-3 elementor-page elementor-page-1050">
        <div id="page" className="jkit-template site">
          <div data-elementor-type="wp-page" data-elementor-id="1050" className="elementor elementor-1050">
            <div data-elementor-type="wp-page" data-elementor-id="1050" className="elementor elementor-1050">
              {/* Hero Section */}
              <div className="elementor-element elementor-element-bdbb4a9 e-flex e-con-boxed e-con e-parent" data-id="bdbb4a9" data-element_type="container" data-settings='{"background_background":"gradient","content_width":"boxed"}' data-core-v316-plus="true">
                <div className="e-con-inner">
                  <div className="elementor-element elementor-element-2d2b035 e-con-full e-flex e-con e-child" data-id="2d2b035" data-element_type="container" data-settings='{"content_width":"full"}'>
                    <div className="elementor-element elementor-element-30e7754 elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-heading" data-id="30e7754" data-element_type="widget" data-settings='{"_animation":"fadeInUp"}' data-widget_type="heading.default">
                      <div className="elementor-widget-container">
                        <h5 className="elementor-heading-title elementor-size-default">About Us</h5>
                      </div>
                    </div>
                    <div className="elementor-element elementor-element-641798f elementor-widget__width-initial elementor-widget-mobile__width-inherit elementor-invisible elementor-widget elementor-widget-jkit_animated_text" data-id="641798f" data-element_type="widget" data-settings='{"_animation_delay":200,"_animation":"fadeInUp"}' data-widget_type="jkit_animated_text.default">
                      <div className="elementor-widget-container">
                        <div className="jeg-elementor-kit jkit-animated-text jeg_module_1050_2_676b7a2b716bd" data-style="highlighted" data-text="Revolution" data-shape="underline">
                          <h1 className="animated-text">
                            <span className="normal-text style-color">Creating the</span>
                            <span className="normal-text style-color"> Future:
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 150" preserveAspectRatio="none">
                                <path className="style-color" d="M3,77.5s200.54-11,493,0" transform="translate(-2.75 -68.11)"/>
                              </svg>
                            </span>
                            <span className="normal-text style-color">Intelligent Design & Advanced Manufacturing</span>
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Our Story Section */}
              <div className="elementor-element elementor-element-3fd02d5 e-flex e-con-boxed e-con e-parent" data-id="3fd02d5" data-element_type="container" data-settings='{"content_width":"boxed"}' data-core-v316-plus="true">
                <div className="e-con-inner">
                  <div className="elementor-element elementor-element-836cbbe e-con-full e-flex e-con e-child" data-id="836cbbe" data-element_type="container" data-settings='{"content_width":"full"}'>
                    <div className="elementor-element elementor-element-b29317c e-con-full e-flex e-con e-child" data-id="b29317c" data-element_type="container" data-settings='{"content_width":"full"}'>
                      <div className="elementor-element elementor-element-d400f8d elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="d400f8d" data-element_type="widget" data-widget_type="heading.default">
                        <div className="elementor-widget-container">
                          <h5 className="elementor-heading-title elementor-size-default">Our Story</h5>
                        </div>
                      </div>
                      <div className="elementor-element elementor-element-93b6ef8 elementor-widget__width-initial elementor-widget-tablet__width-initial elementor-widget elementor-widget-jkit_heading" data-id="93b6ef8" data-element_type="widget" data-widget_type="jkit_heading.default">
                        <div className="elementor-widget-container">
                          <div className="jeg-elementor-kit jkit-heading align-left align-tablet- align-mobile- jeg_module_1050_4_676b7a2b79e09">
                            <div className="heading-section-title display-inline-block">
                              <h4 className="heading-title">Welcome to HHG Industries, where we've been delivering <span className="style-color"><span>innovation and transformative</span></span> automation solutions since 2024.</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="elementor-element elementor-element-dd3e9a5 elementor-widget__width-initial elementor-widget elementor-widget-text-editor" data-id="dd3e9a5" data-element_type="widget" data-widget_type="text-editor.default">
                        <div className="elementor-widget-container">
                          At HHG Industries, we deliver innovative design and manufacturing solutions for automotive, aeronautical industry, infrastructure, and other various sectors. We integrate advanced technologies including artificial intelligence, and robotics, when combined together with human interaction contributes towards a proliferating and sustainable environment in the future.
                        </div>
                      </div>
                    </div>
                    <div className="elementor-element elementor-element-9ee2b7b e-con-full e-flex e-con e-child" data-id="9ee2b7b" data-element_type="container" data-settings='{"content_width":"full"}'>
                      <div className="elementor-element elementor-element-6f785b5 elementor-widget elementor-widget-image" data-id="6f785b5" data-element_type="widget" data-widget_type="image.default">
                        <div className="elementor-widget-container">
                          <img decoding="async" className="single-image" src={image} alt="HHG Industries Automation" style={{ width: '100%', height: 'auto', maxHeight: '500px', objectFit: 'contain' }} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Vision & Mission Section */}
              <div className="elementor-element elementor-element-d114a46 e-flex e-con-boxed e-con e-parent" data-id="d114a46" data-element_type="container" data-settings='{"content_width":"boxed"}' data-core-v316-plus="true">
                <div className="e-con-inner">
                  <div className="elementor-element elementor-element-740107e e-con-full e-flex e-con e-child" data-id="740107e" data-element_type="container" data-settings='{"content_width":"full"}'>
                    <div className="elementor-element elementor-element-b8b1603 elementor-widget elementor-widget-image" data-id="b8b1603" data-element_type="widget" data-widget_type="image.default">
                      <div className="elementor-widget-container">
                        <img decoding="async" width="800" height="964" src={vision} className="attachment-large size-large wp-image-1114" alt="Robotic Arm modern industrial technology. Automated production c" sizes="(max-width: 800px) 100vw, 800px" style={{ width: '100%', height: 'auto' }} />
                      </div>
                    </div>
                  </div>
                  <div className="elementor-element elementor-element-db0e5e2 e-con-full e-flex e-con e-child" data-id="db0e5e2" data-element_type="container" data-settings='{"content_width":"full"}'>
                    <div className="elementor-element elementor-element-869af5c elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="869af5c" data-element_type="widget" data-widget_type="heading.default">
                      <div className="elementor-widget-container">
                        <h5 className="elementor-heading-title elementor-size-default">Our Vision & Mission</h5>
                      </div>
                    </div>
                    <div className="elementor-element elementor-element-ceb0f99 elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-jkit_feature_list" data-id="ceb0f99" data-element_type="widget" data-widget_type="jkit_feature_list.default">
                      <div className="elementor-widget-container">
                        <div className="jeg-elementor-kit jkit-feature-list icon-position-left icon-position-left icon-position-left jeg_module_1050_9_676b7a2b8a3d4">
                          <ul className="feature-list-items shape-circle shape-view-stacked connector-type-classic">
                            <li className="feature-list-item elementor-repeater-item-5c9e9bc">
                              <span className="connector"></span>
                              <div className="feature-list-icon-box">
                                <div className="feature-list-icon-inner">
                                  <span className="feature-list-icon">
                                    <i aria-hidden="true" className="fas fa-circle"></i>
                                  </span>
                                </div>
                              </div>
                              <div className="feature-list-content-box">
                                <h4 className="feature-list-title">Vision</h4>
                                <p className="feature-list-content">To develop and deliver cutting-edge AI-based Design for Manufacturing (DFM) solutions that empower our customers to streamline their products with high-added value and innovative technological solutions through sustainable and competitive growth development processes and optimize manufacturing efficiency in a significantly reduced timeframe.</p>
                              </div>
                            </li>
                            <li className="feature-list-item elementor-repeater-item-0b496d9">
                              <span className="connector"></span>
                              <div className="feature-list-icon-box">
                                <div className="feature-list-icon-inner">
                                  <span className="feature-list-icon">
                                    <i aria-hidden="true" className="fas fa-circle"></i>
                                  </span>
                                </div>
                              </div>
                              <div className="feature-list-content-box">
                                <h4 className="feature-list-title">Mission</h4>
                                <p className="feature-list-content">We deliver global and innovative design and manufacturing solutions for the Automotive, MES, EV, Aeronautical, Infrastructure, and other industrial sectors, integrating advanced technologies such as robotics and artificial intelligence that together with human interaction contribute to more sustainable development.</p>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            
            </div>
            {/* <AbutFaq /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default About;